var exports = {
  "k": "NagbarContainer.module__container___VFpUQm",
};

module.exports = exports;
